import { Outlet } from '@tanstack/react-router'
import { Sidebar } from '@/components/layout/sidebar'
import { Header } from '@/components/layout/header'
import { useAuthStore, AUTH_DISABLED } from '@/stores/auth'

/**
 * Shell do dashboard — porta de `src/app/(dashboard)/layout.tsx`.
 *
 * Na versão Next este layout era um Server Component: validava a sessão com
 * `serverFetch('/api/auth/me')` e chamava `redirect('/login')`. Aqui a
 * validação acontece antes, no `beforeLoad` da rota (ver `src/router/index.tsx`),
 * então quando este componente monta a sessão já está garantida e o store
 * apenas fornece os dados.
 */
export function DashboardLayout() {
  const user = useAuthStore(s => s.user)
  const systemName = useAuthStore(s => s.systemName)

  // Com AUTH_DISABLED o guard não roda e `user` fica nulo — usa um placeholder
  // para o Header não quebrar em desenvolvimento.
  const headerUser = user ?? {
    id: '',
    name: AUTH_DISABLED ? 'Dev' : '',
    email: '',
    role: 'ADMIN',
  }

  return (
    <div className="flex h-screen" style={{ background: '#FAF8F3' }}>
      <Sidebar systemName={systemName} />
      <div className="flex flex-col flex-1 overflow-hidden">
        <Header user={headerUser} />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
